export enum ShopperAgentConfigStatus {
  Draft = "draft",
  Published = "published",
  Archived = "archived",
}
